import * as React from 'react';

export const VKPixel = () => {
  return (
    <>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html:
            '!function(){\n' +
            '    var t=document.createElement("script");\n' +
            '    t.type="text/javascript",\n' +
            '        t.async=!0,t.src="https://vk.com/js/api/openapi.js?169",t.onload=function(){\n' +
            '        VK.Retargeting.Init("VK-RTRG-806171-6CkZh"),VK.Retargeting.Hit()},\n' +
            '        document.head.appendChild(t)}();',
        }}
      ></script>
      <noscript>
        <img src="https://vk.com/rtrg?p=VK-RTRG-806171-6CkZh" style={{ position: 'fixed', left: '-999px' }} alt="" />
      </noscript>
    </>
  );
};
